import React, { FunctionComponent, useEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import styles from "./Common.module.scss";
import { data } from './local';
import Grid from '@mui/material/Grid';
import { Button, createStyles, InputLabel, makeStyles, MenuItem, Paper, Popper, Select, TextField } from '@material-ui/core';
import { Theme } from '@mui/material/styles';
import { DataGrid, GridColDef, GridEditRowsModel, GridRenderCellParams } from '@mui/x-data-grid';
import { getCategoryMap, getToken, getUserGraphId } from './common';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { Autocomplete, Stack, Typography } from '@mui/material';
import { getNominationsByYearMonthRegionMinistryTitle, getNominationsByYearMonthRegionMinistryTitleCount, getNomineesByYearMonthRegionMinistryList, getRegionMinistryDistinctList, insertNomination } from './services';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { appInsights } from '../AppInsights';
import { NotificationAlert } from "./NotificationAlert";
import { isNullOrUndefined } from '@microsoft/applicationinsights-core-js';
import { startYear } from './constants';


const AddComments: FunctionComponent<any> = () => {
  let history: any = useHistory();
  const [token, setToken] = useState<any>(null);

  const languageSelected: any = useSelector((state: any) => state.lang);
  const languageData: any = data;
  const { VIANominations } = languageData[languageSelected];

  const [year, setYear] = React.useState(new Date().getFullYear());
  const fullMonth = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const [month, setMonth] = React.useState<string>(fullMonth[new Date().getMonth()]);
  const [region, setRegion] = React.useState(null);
  const [regionList, setRegionList] = React.useState<string[]>();
  const [ministry, setMinistry] = React.useState(null);
  const [ministryList, setMinistryList] = React.useState<string[]>();
  const [nominee, setNominee] = React.useState(null);
  const [nomineeList, setNomineeList] = React.useState<string[]>();

  const [monthYearSelected, setMonthYearSelected] = useState<boolean>(false);

  var fullNominationsList: any = [];
  const [nominationsList, setNominationsList] = React.useState<any>();

  const [editRowsModel, setEditRowsModel] = React.useState({});
  const handleEditRowsModelChange = React.useCallback((model: GridEditRowsModel) => {
    setEditRowsModel(model);
  }, []);

  const [rowCount, setRowCount] = React.useState<number | undefined>(undefined);

  const [isLoading, setLoading] = useState<boolean>(false);
  const [nomineeDisabled, setNomineeDisabled] = useState<boolean>(true);

  const [commentsToUpdate, setCommentsToUpdate] = React.useState<any>();
  const [openForUpdateComments, setOpenForUpdateComments] = React.useState(false);
  const [alertType, setAlertType] = useState('');
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState<any>('');
  const [count, Setcount] = useState(0);
  const [submittedOn, setSubmittedOn] = useState<any>('');


  interface RowsState {
    page: number;
    pageSize: number;
  }

  const [rowsState, setRowsState] = React.useState<RowsState>({
    page: 0,
    pageSize: 10,
  });

  const getcorrelationId = () => {
    return sessionStorage.getItem("correlationId");
  }

  useEffect(() => {
    getToken().then((token: any) => {
      setToken(token);
    });
  }, [])

  useEffect(() => {
    GetRegions();
    GetMinistries();
  }, [])

  useEffect(() => {
    setRowsState({ page: 0, pageSize: rowsState.pageSize });
  }, [year, month, region, ministry, nominee])

  useEffect(() => {
    setNominationsList([]);
    setEditRowsModel({});
    if (year && month) {
    setMonthYearSelected(true);
      let options = {
        year: year,
        month: fullMonth.indexOf(month) + 1,
        region: region,
        ministry: ministry,
        title: nominee,
        pageIndex: rowsState.page + 1,
        pageSize: rowsState.pageSize
      }
      getRowCount();
      setNomineeDisabled(false);
      GetNominationsByYearMonthRegionMinistryTitle(options);
      if(!nominee){
      setLoading(true);
      GetNomineesByYearMonthRegionMinistry(options);
      setLoading(false);
      }
    }
    else if (region || ministry || nominee){
      setAlertType('error');
      setAlertContent('Please select year and month to proceed');
      setAlert(true);
      setTimeout(() => { setAlert(false); }, 4000);
      setRegion(null);
      setMinistry(null);
      setNominee(null);
    }
  }, [year, month, region, ministry, nominee, rowsState.page, rowsState.pageSize, count])


  function getRowCount() {
    setRowCount(undefined);
    if (year && month) {
      getCountByYearMonthRegionMinistryTitle().then((response: any) => {
        if (response != null) {
          setRowCount(response);
        }
      });
    }
  }

  async function getCountByYearMonthRegionMinistryTitle() {
    let options = {
      year: year,
      month: fullMonth.indexOf(month) + 1,
      region: region,
      ministry: ministry,
      title: nominee
    }
    let response: any = await getNominationsByYearMonthRegionMinistryTitleCount(options);
    return response;
  }

  const [rowCountState, setRowCountState] = React.useState(rowCount || 0);

  React.useEffect(() => {
    setRowCountState((prevRowCountState) =>
      rowCount !== undefined ? rowCount : prevRowCountState,
    );
  }, [rowCount, setRowCountState]);

  const GetNominationsByYearMonthRegionMinistryTitle = (options: any) => {
    setNominationsList([]);
    getNominationsByYearMonthRegionMinistryTitle(options).then((response: any) => {
      if (response != null) {
        if (response.nominationsWithComments != undefined && response.nominationsWithComments != null) {
          fullNominationsList = response.nominationsWithComments;
          let ListOfNominations = [];
          for (let key in fullNominationsList) {
            ListOfNominations.push({
              id: key,
              Nominee: fullNominationsList[key].title,
              NomineeEmail: fullNominationsList[key].nomineeEmail,
              NomineeTitle: fullNominationsList[key].nomineeTitle,
              NomineeCompany: fullNominationsList[key].nomineeCompany,
              NomineeCity: fullNominationsList[key].nomineeCity,
              Region: fullNominationsList[key].region,
              Ministry: fullNominationsList[key].ministry,
              NominationText: fullNominationsList[key].nominationText,
              NomineeManager: fullNominationsList[key].nomineeManager,
              NomineeManagerEmail: fullNominationsList[key].nomineeManagerEmail,
              NominatorName: fullNominationsList[key].nominatorName,
              NominatorEmail: fullNominationsList[key].nominatorEmail,
              DateSubmitted: new Date(fullNominationsList[key].dateSubmitted).toLocaleDateString('en-GB'),
              AnonymousNominatorId: fullNominationsList[key].hiddenNominatorEmail,
              NominatorId: fullNominationsList[key].nominatorId,
              NomineeId: fullNominationsList[key].nomineeId,
              ReviewerNotes: fullNominationsList[key].reviewerNotes
            });
            setSubmittedOn(fullNominationsList[key].dateSubmitted);
          }
          setNominationsList(ListOfNominations);
        }
      }

    });
  };

  const GetRegions = () => {
    getRegionMinistryDistinctList("region").then((response: any) => {
      if (response != null) {
        let ListOfRegions: string[] = [];
        let key: any;
        for (key in response) {
          ListOfRegions[key] = response[key].region;
        }
        setRegionList(ListOfRegions);
      }
    });
  };

  const GetMinistries = () => {
    getRegionMinistryDistinctList("ministry").then((response: any) => {
      if (response != null) {
        let ListOfMinistries: string[] = [];
        let key: any;
        for (key in response) {
          ListOfMinistries[key] = response[key].ministry;
        }
        setMinistryList(ListOfMinistries);
      }
    });
  };

  const GetNomineesByYearMonthRegionMinistry = (options: any) => {
    getNomineesByYearMonthRegionMinistryList(options).then((response: any) => {
      setNomineeList([]);
      if (response != null) {
        let ListOfNominees: string[] = [];
        let key: any;
        for (key in response.nominees) {
          ListOfNominees[key] = response.nominees[key].title;
        }
        setNomineeList(ListOfNominees);
      }
    });
  };

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'Nominee', headerName: 'Nominee', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'NomineeEmail', headerName: 'Nominee Email', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'NomineeTitle', headerName: 'Nominee Title', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'NomineeCompany', headerName: 'Nominee Company', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'NomineeCity', headerName: 'Nominee City', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'Region', headerName: 'Region', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'Ministry', headerName: 'Ministry', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'NominationText', headerName: 'Nomination Text', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'NomineeManager', headerName: 'Nominee Manager', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'NomineeManagerEmail', headerName: 'Manager Email', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'NominatorName', headerName: 'Nominator Name', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'NominatorEmail', headerName: 'Nominator Email', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'AnonymousNominatorId', headerName: 'Anonymous Nominator Id', minWidth: 250, flex: 1, renderCell: renderCellExpand },
    { field: 'NominatorId', headerName: 'Nominator Id', hide: true },
    { field: 'NomineeId', headerName: 'Nominee Id', hide: true },
    { field: 'DateSubmitted', headerName: 'Submitted On', minWidth: 150, flex: 1 },
    { field: 'ReviewerNotes', headerName: 'Reviewer Notes', editable: true, minWidth: 250, flex: 1, renderCell: renderCellExpand },
    {
      field: 'actions', type: 'actions', minWidth: 150, flex: 0.5,
      renderCell: (cellvalues: any) => (
        <strong>

          {cellvalues.value}

          <Button
            className={styles.AddAwardeeBttn}
            variant="contained"
            color="primary"
            size="small"
            style={{ marginBottom: '16px' }}
            onClick={() => handleSaveClick(cellvalues, editRowsModel)}
          > Save  </Button>
        </strong>
      )
    }
  ]

  function handleSaveClick(cellvalues: any, editRowsModel: any) {
    if (cellvalues.row.id == Object.keys(editRowsModel)[0]) {
      if (!isNullOrUndefined(editRowsModel) && Object.keys(editRowsModel).length != 0) {
        Update(cellvalues, editRowsModel);
      }
    }
    else {
      setAlertType('error');
      setAlertContent('Reviewer Notes is not modified to save.');
      setAlert(true);
      setTimeout(() => { setAlert(false); }, 4000);
    }
  }

  function Update(value: any, value2: any) {
    const valueSelected: any = Object.values(value2)[0];

    value.row.ReviewerNotes = valueSelected['ReviewerNotes'].value;
    if (value.row.ReviewerNotes != "" && value.row.ReviewerNotes != null) {
      setCommentsToUpdate(value.row);
      setOpenForUpdateComments(true);
    }
    else {
      setAlertType('error');
      setAlertContent('Please enter Reviewer Notes to proceed!');
      setAlert(true);
      setTimeout(() => { setAlert(false); }, 4000);
    }
  }

  const insertNominationWithComments = async () => {
    let options = {
      "title": commentsToUpdate.NomineeTitle,
      "nominatorId": commentsToUpdate.NominatorId,
      "nomineeId": commentsToUpdate.NomineeId,
      "nominatorEmailHash": commentsToUpdate.NominatorEmail,
      "notes": commentsToUpdate.NominationText,
      "state": 2,
      "categoryId": getCategoryMap().get("via nominations"),
      "groupName": "",
      "groupEmail": "",
      "nominationYear": new Date(submittedOn).getFullYear(),
      "isAnonymous": commentsToUpdate.AnonymousNominatorId == null ? false : true,
      "managerName": commentsToUpdate.NomineeManager,
      "managerEmail": commentsToUpdate.NomineeManagerEmail,
      "reviewerNotes": commentsToUpdate.ReviewerNotes
    }
    await insertNomination(options);
  }

  const UpdateCommentsbuttonHandler = async () => {
    setOpenForUpdateComments(false);
    await insertNominationWithComments();
    setAlertContent('Updated details successfully.!');
    setAlertType('success');
    setAlert(true);
    appInsights.trackEvent({ name: "Updated Comments", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } })
    setTimeout(() => { setAlert(false); }, 3000);
    setEditRowsModel({});
  };

  const handleClose = () => {
    Setcount((count: number) => count + 1);
    setOpenForUpdateComments(false);
    setCommentsToUpdate(null);
    setEditRowsModel({});
    Setcount((count: number) => count + 1);
  };

  const handleYearChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setYear(event.target.value as any);
  };

  const handleMonthChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setMonth(event.target.value as any);
  };

  const classes = useStyles();

  return (
    <React.Fragment>
      <Container maxWidth={"xl"} >
        <div className={styles.adminPage} style={{ height: 'max-content' }}>
          {alert && <NotificationAlert state={alert} notificationMessage={alertContent} alertType={alertType} />}
          <h2 className={styles.headerBold}>Add reviewer notes to nominations</h2>

          <div>
            <DataSelect
              ministry={ministry}
              ministryList={ministryList}
              setMinistry={setMinistry}
              region={region}
              regionsList={regionList}
              setRegion={setRegion}
              nominee={nominee}
              nomineeList={nomineeList}
              setNominee={setNominee}
              nomineeDisabled={nomineeDisabled}
              isLoading={isLoading}
              handleYearChange={handleYearChange}
              year={year}
              handleMonthChange={handleMonthChange}
              month={month}
            />

          </div>

          {monthYearSelected ? <div>
            <hr />
            <div style={{ height: 600, width: '100%' }}>

              <DataGrid
                disableColumnFilter
                rows={nominationsList}
                columns={columns}
                className={classes.root}
                rowsPerPageOptions={[10]}
                rowHeight={40}
                editRowsModel={editRowsModel}
                editMode="row"
                onEditRowsModelChange={handleEditRowsModelChange}
                rowCount={rowCountState}
                pagination
                {...rowsState}
                paginationMode="server"
                onPageChange={(page) => setRowsState((prev) => ({ ...prev, page }))}
                onPageSizeChange={(pageSize) =>
                  setRowsState((prev) => ({ ...prev, pageSize }))}
                components={{
                  NoRowsOverlay: () => (
                    <Stack height="100%" alignItems="center" justifyContent="center">
                      No Data for the selected combination
                    </Stack>
                  ),
                  NoResultsOverlay: () => (
                    <Stack height="100%" alignItems="center" justifyContent="center">
                      No Data for the selected combination
                    </Stack>
                  )
                }}
              />
            </div>
          </div> : ''}
          <Dialog
            open={openForUpdateComments}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" style={{ backgroundColor: '#00338e', fontFamily: 'barlow', color: '#FFFFFF' }}>
              {"Update Row "}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to update this row?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={styles.messageBoxEditor} onClick={UpdateCommentsbuttonHandler} autoFocus>
                Yes
              </Button>
              <Button className={styles.messageBoxEditor} onClick={handleClose}>No</Button>

            </DialogActions>
          </Dialog>
        </div>
      </Container>
    </React.Fragment>
  );
}

const DataSelect = ({ region, regionsList, setRegion, ministry, setMinistry, ministryList, nominee, nomineeList, setNominee, nomineeDisabled, isLoading, year, handleYearChange, month, handleMonthChange }: any) => {
  const languageSelected: any = useSelector((state: any) => state.lang);
  const languageData: any = data;
  const { nominationSection } = languageData[languageSelected];
  const fullMonth = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const years: any = [];
  for (let i = 0; i < 3; i++) {
    if ((new Date().getFullYear() - +i) >= startYear) {
      years.push(new Date().getFullYear() - +i)
    }
  }

  const months: any = [];
  if (year == new Date().getFullYear()) {
    for (let i = 0; i <= new Date().getMonth(); i++) {
      months.push(fullMonth[i]);
    }
  }
  else if (year != new Date().getFullYear()) {
    for (let i = 0; i < 12; i++) {
      months.push(fullMonth[i]);
    }
  }

  return (
    <div>
      <form >
        <Grid container
          rowSpacing={1}
          spacing={2}
          wrap="nowrap"
          direction="row">
          <Grid item xs={1}>
            <InputLabel
              className={styles.nominationYearSelectorDarkAdmin}
              shrink id="demo-simple-select-placeholder-label-label"
              required={true}>
              {nominationSection.year}
            </InputLabel>
            <Select
              autoWidth
              labelId="demo-simple-select-placeholder-label-label"
              id="demo-simple-select-placeholder-label"
              value={year}
              onChange={handleYearChange}
              displayEmpty
              className={styles.nominationYearSelectorLiteAdmin}
            >
              {
                years.map((year: any, key: number) => {
                  return <MenuItem key={key} value={year}>{year}</MenuItem>
                })
              }
            </Select>
          </Grid>
          <Grid item xs={2}>
            <InputLabel
              className={styles.nominationYearSelectorDarkAdmin}
              shrink id="demo-simple-select-placeholder-label-label"
              required={true}>
              Month
            </InputLabel>
            <Select
              autoWidth
              labelId="demo-simple-select-placeholder-label-label"
              id="demo-simple-select-placeholder-label"
              value={month}
              onChange={handleMonthChange}
              displayEmpty
              className={styles.nominationYearSelectorLiteAdmin}
            >
              {
                months.map((month: any, key: number) => {
                  if (!isNullOrUndefined(year)) {
                    return <MenuItem key={key} value={month}>{month}</MenuItem>
                  }
                })
              }
            </Select>
          </Grid>
          <Grid item xs={3}>
            <InputLabel className={styles.nominationYearSelectorDarkAdmin} shrink id="demo-simple-select-placeholder-label-label">
              Region
            </InputLabel>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={regionsList}
              value={region}
              onChange={(event: any, newValue: string | null) => {
                setRegion(newValue);
              }}
              className={styles.nominationYearSelectorLiteAdmin}
              style={{ paddingBottom: '5px' }}
              renderInput={(params) => <TextField {...params} InputProps={{ ...params.InputProps, disableUnderline: true, style: { color: '#00338E' } }} />}
            />
          </Grid>
          <Grid item xs={3}>
            <InputLabel className={styles.nominationYearSelectorDarkAdmin} shrink id="demo-simple-select-placeholder-label-label">
              Ministry
            </InputLabel>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={ministryList}
              value={ministry}
              onChange={(event: any, newValue: string | null) => {
                setMinistry(newValue);
              }}
              className={styles.nominationYearSelectorLiteAdmin}
              style={{ paddingBottom: '5px' }}
              renderInput={(params) => <TextField {...params} InputProps={{ ...params.InputProps, disableUnderline: true, style: { color: '#00338E' } }} />}
            />
          </Grid>
          <Grid item xs={3}>
            <InputLabel className={styles.nominationYearSelectorDarkAdmin} shrink id="demo-simple-select-placeholder-label-label">
              Nominee
            </InputLabel>
            <Autocomplete
              disabled={nomineeDisabled}
              disablePortal
              loading={isLoading}
              id="combo-box-demo"
              options={nomineeList}
              value={nominee}
              onChange={(event: any, newValue: string | null) => {
                setNominee(newValue);
              }}
              noOptionsText={<div >
                <span style={{ color: "#3f51b5" }} >
                  No Nominees for this combination
                </span>
              </div>}
              className={styles.nominationYearSelectorLiteAdmin}
              style={{ paddingBottom: '5px' }}
              renderInput={(params) => <TextField {...params} InputProps={{ ...params.InputProps, disableUnderline: true, style: { color: '#00338E' } }} />}
            />
          </Grid>
        </Grid>
      </form>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: 0,

      fontFamily: 'Barlow !important',
      backgroundColor: '#FFFFFF',

      '& .MuiDataGrid-cell:hover': {
        color: '#00338e',
      },
      '& .MuiDataGrid-columnHeader': {
        color: '#FFFFFF',
        backgroundColor: '#00338e',
        fontSize: 'calc(2px + 2vmin)',
        '& .MuiCheckbox-root svg path': {
          color: 'white',
        }
      },
      '& .MuiDataGrid-columnHeadersInner': {
        backgroundColor: '#00338e'
      },
      '& .MuiDataGrid-cell': {
        fontSize: 'calc(2px + 1.5vmin)'
      },
      '& .MuiCheckbox-root svg path': {
        color: '#00338e',
      },
      '& .MuiDataGrid-root .MuiDataGrid-cell.MuiDataGrid-cell--editing:focus-within': {
        backgroundColor: '#00338e'
      },
      '& .MuiDataGrid-cell--editing': {
        backgroundColor: '#f0f5ff !important',
      },
    },

  }),
);

const useStyles1 = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      //  margin: theme.spacing(1),
      minWidth: 120,
      float: 'right',
      marginTop: theme.spacing(-5),
    },
    [theme.breakpoints.down(850)]: {
      formControl: {
        //  margin: theme.spacing(1),
        minWidth: 10,
        float: 'inline-end',
        marginTop: theme.spacing(-0),
      },
      minWidth: 10,
      float: 'right',
      marginTop: theme.spacing(-100),
    },
    selectEmpty: {
      marginTop: theme.spacing(10),
      position: 'relative'
    },
  }),
);

interface GridCellExpandProps {
  value: string;
  width: number;
}

function isOverflown(element: Element): boolean {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

const GridCellExpand = React.memo(function GridCellExpand(
  props: GridCellExpandProps,
) {
  const { width, value } = props;
  const wrapper = React.useRef<HTMLDivElement | null>(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);

  const handleMouseEnter = () => {
    const isCurrentlyOverflown = isOverflown(cellValue.current!);
    setShowPopper(isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowFullCell(false);
  };

  React.useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }

    function handleKeyDown(nativeEvent: KeyboardEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        setShowFullCell(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);

  return (
    <Box
      ref={wrapper}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        alignItems: 'center',
        lineHeight: '24px',
        width: 1,
        height: 1,
        position: 'relative',
        display: 'flex',
      }}
    >
      <Box
        ref={cellDiv}
        sx={{
          height: 1,
          width,
          display: 'block',
          position: 'absolute',
          top: 0,
        }}
      />
      <Box
        ref={cellValue}
        sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {value}
      </Box>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          style={{ width, marginLeft: -17 }}
        >
          <Paper
            elevation={1}
            style={{ minHeight: wrapper.current!.offsetHeight - 3 }}
          >
            <Typography variant="body2" style={{ padding: 8 }}>
              {value}
            </Typography>
          </Paper>
        </Popper>
      )}
    </Box>
  );
});

function renderCellExpand(params: GridRenderCellParams<string>) {
  return (
    <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth * 3} />
  );
}


export default AddComments;


